import React from 'react';
import type { CarouselImages } from '../image/Carousel';
import Carousel, { useCarousel } from '../image/Carousel';
import CarouselControls from '../image/CarouselControls';
import CarouselSlider from '../image/CarouselSlider';
import CarouselThumbnailBar from '../image/CarouselThumbnailBar';
import styles from './CarouselModalContent.module.scss';
import { useIsSize } from '../../utils/responsive/isSize';
import Sizes from '../../utils/responsive/Sizes';
import MobileCarouselSlider from '../image/MobileCarouselSlider';

const Caption = () => {
  const { images, currentIndex } = useCarousel();

  const image = images[currentIndex];

  return <div className={styles.caption}>{image?.caption}</div>;
};

interface CarouselModalContentProps {
  images: CarouselImages;
  index: number;
}

const CarouselModalContent = ({ images, index }: CarouselModalContentProps) => {
  const isMobile = useIsSize(Sizes.SM);

  return (
    <Carousel images={images} initialIndex={index}>
      <div className={styles.sliderContainer}>
        {isMobile ? (
          <MobileCarouselSlider />
        ) : (
          <CarouselSlider singleMode dragDisabled fullscreen />
        )}
        <div className={styles.controlsContainer}>
          <CarouselControls arrowKeysEnabled />
        </div>
      </div>
      <Caption />
      <div className={styles.thumbnailBarContainer}>
        <CarouselThumbnailBar />
      </div>
    </Carousel>
  );
};

export default CarouselModalContent;
